import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/compas.svg'


const _hoisted_1 = { class: "compas-section text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "compas-title" }, "ВАШ НАДЕЖНЫЙ КОМПАС В МИРЕ БИЗНЕСА"),
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "icon1"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}